import Site from "types/Site";
import SiteSearchResult from "types/SiteSearchResult";

export const siteFullname = (site: Site | SiteSearchResult): string =>
    site.name ? `${site.id} - ${site.name}` : `${site.id}`;
